/**
 * @type Function
 * @description Page restore for mobile iOS - without this back/forward buttons won't hide ie. loader covers (if there are any).
 */

const pageRestore = {
  init(): void {
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        window.location.reload()
      }
    })
  },
}

export default pageRestore
